const { slice } = Array.prototype;

export default function toArray(object) {
  return slice.call(object);
}
